<template>
  <div class="cell cell-id cell-id-icons">
    <Icon type="drag" class="cell-id_drag" />
    <div
      draggable="true"
      class="cell-id_drag-fake pointer"
      @dragstart="startDrag"
      @dragend="endDrag"
    >
      fake drag
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'IconsCell',
    components: {
      Icon,
    },
    props: {
      index: {
        type: [String, Number],
        default: '',
      },
      noButtons: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      startDrag() {
        this.$emit('startDrag');
      },
      endDrag() {
        this.$emit('endDrag');
      },
      addNew() {
        this.$emit('add');
      },
      openOptions(e) {
        this.$emit('options', e);
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/colors';
</style>
